const formatDetailItem = (item) => {
  if (!item) return ''
  if (typeof item === 'string') return item

  const location = Array.isArray(item.loc) ? item.loc.join('.') : ''
  const message = item.msg || item.message || item.error || ''

  if (location && message) return location + ': ' + message
  if (message) return message

  return ''
}

const getDataMessage = (data) => {
  if (!data) return ''
  if (typeof data === 'string') return data
  if (typeof data.message === 'string') return data.message
  if (typeof data.error === 'string') return data.error
  if (typeof data.detail === 'string') return data.detail

  if (Array.isArray(data.detail)) {
    return data.detail.map(formatDetailItem).filter(Boolean).join('; ')
  }

  if (data.detail && typeof data.detail === 'object') {
    return formatDetailItem(data.detail)
  }

  return ''
}

export const getApiErrorMessage = (error, fallback = 'Erro na requisição.') => {
  const response = (error || {}).response || {}
  const message = getDataMessage(response.data)

  if (message) return message

  if (response.status) {
    return fallback ? fallback + ' HTTP ' + response.status + '.' : 'HTTP ' + response.status + '.'
  }

  if (error && typeof error.message === 'string') {
    return error.message
  }

  return fallback
}

export default getApiErrorMessage



// WEBPACK FOOTER //
// ./src/utils/apiErrorMessage.js